// import { SearchBarAndFiltersUserOfSuscriber } from '../SearchAndFIlter/SearchBarAndFiltersUserOfSuscriber'
import TableHeader from './TableHeader/TableHeader'
import TableItem from './TableItem/TableItem'

import useStyles from './useStyles'

function SuscribersOfUsersTable ({
  id,
  isOrgTesting,
  rows,
  setRows,
  setLoading
}) {
  const classes = useStyles()

  // get user request
  // const getUsersOfSuscriber = async () => {
  //   try {
  //     const resp = await helpGetUserOfSuscriber(id)
  //     setRows(resp.data)
  //   } catch (err) {
  //     setRows([])
  //   }
  // }

  // get users of Suscriber of Organization

  return (
    <>
      <div className={classes.root}>
        <div className={classes.tableWrap}>
          <table className={classes.table}>
            <TableHeader />
            <tbody className={classes.tableBody}>
              {rows &&
                rows.map((item, index) => (
                  <TableItem
                    listIndex={index}
                    key={item.subscriber_id}
                    item={item}
                    setLoading={setLoading}
                    setRows={setRows}
                    isOrgTesting={isOrgTesting}
                  />
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
export default SuscribersOfUsersTable
